export const kr = {
  kr: {
    logout: `로그아웃`,
    game: `game`,
    history: `history`,
    back: `back`,
    maintenance: `maintenance`,
    maintenance_desc: `We will be back shortly`,
    play_now: `play now`,

    logout_title: `<i class="tx--logout -kr"></i>`,
    alert_title: `<i class="tx--alert -kr"></i>`,
    chat_title: `<i class="tx--chat -kr"></i>`,

    sort: `sort`,

    //= language
    language: [
      { id: 0, name: 'en' },
      { id: 2, name: 'jp' },
      { id: 1, name: 'kr' },
      { id: 3, name: 'zh' }
    ],

    //= navigation
    home: `home`,
    popular: `popular`,
    live_games: `live games`,
    table_games: `table games`,
    slot_games: `slot games`,
    other_games: `other games`,

    //= alerts
    error: `에러`,
    prompt: `are you sure?`,
    info: `상세정보`,
    success: `성공`,

    ok: `예`,
    cancel: `취소`,
    failed: `실패`,

    //= titles
    slot_payline: `slot payline`,
    game_provider: `game provider`,
    faq: `faq`
  }
}
